import api from './api';

export interface QuizContainer {
  id: number;
  title: string;
  description: string;
  parent: number | null;
  thumbnail: number | null;
  thumbnail_url: string | null;
  created_by: number;
  created_at: string;
  updated_at: string;
  order: number;
  children_count: number;
  quizzes_count: number;
}

class QuizContainerService {
  async getContainers(parentId: number | null = null): Promise<QuizContainer[]> {
    const params = parentId === null ? { parent: 'null' } : { parent: parentId };
    const response = await api.get('/quiz-containers/', { params });
    // Handle paginated response
    if (response.data && response.data.results) {
      return response.data.results;
    }
    return response.data;
  }

  async getContainer(id: number): Promise<QuizContainer> {
    const response = await api.get(`/quiz-containers/${id}/`);
    return response.data;
  }

  async getContainerContents(id: number): Promise<{ containers: QuizContainer[], quizzes: any[] }> {
    const response = await api.get(`/quiz-containers/${id}/contents/`);
    return response.data;
  }

  async createContainer(data: Partial<QuizContainer>): Promise<QuizContainer> {
    const response = await api.post('/quiz-containers/', data);
    return response.data;
  }

  async updateContainer(id: number, data: Partial<QuizContainer>): Promise<QuizContainer> {
    const response = await api.patch(`/quiz-containers/${id}/`, data);
    return response.data;
  }

  async deleteContainer(id: number): Promise<void> {
    await api.delete(`/quiz-containers/${id}/`);
  }

  async reorderContainers(items: { id: number; order: number }[]): Promise<void> {
    await api.post('/quiz-containers/reorder/', { items });
  }
}

const quizContainerService = new QuizContainerService();
export default quizContainerService;
